import { ReactElement } from 'react'
import BasePage from '../layout'
import CertificatesPage from './index'

export default (): ReactElement => (
  <BasePage>
    <CertificatesPage />
  </BasePage>
)
